<ng-container *transloco="let t">
  <div class="admin-card">
    <app-admin-actions-header [isPdfVisible]="false" [isXlsVisible]="false">
      <div slot="trailingWidgets" class="position-relative">
        <div class="input-holder">
          <input type="file" class="file-input cursor-pointer" accept="application/xml" #fileUpload
                 (change)="processFile(fileUpload)">
        </div>
        <app-rounded-button [label]="t('account.statements.add.new')"
                            [btnClass]="'rounded-button--red-outline'" (onClick)="fileUpload.click()"><i
          class="bi bi-plus-circle pe-2"></i></app-rounded-button>
      </div>
    </app-admin-actions-header>
    <div>
      @if ((accountStatements.length ?? 0) > 0) {
        <!-- Desktop -->
        <div>
          <div class="table-responsive d-xl-block d-none">
            <app-sortable-table [infiniteScrollDistance]="4" cssClass="table dark-header table-last-row-no-border"
                                infinite-scroll
                                [items]="accountStatements">
              <thead>
              <tr>
                <th scope="col" [sortBy]="['id']" class="id-column-width">{{ t("account.statements.id") }}</th>
                <th scope="col" [sortBy]="['filename']">{{ t("account.statements.filename") }}</th>
                <th scope="col" [sortBy]="['dateCreated']" class="date-column-width">{{
                    t("account.statements.dateCreated")
                  }}
                </th>
                <th scope="col" class="status-column-width">{{ t("account.statements.status") }}</th>
                <th class="more-column-width"></th>
              </tr>
              </thead>
              <tr app-table-header-separator></tr>
              <tbody>
                @for (accountStatement of accountStatements;track accountStatement) {
                  <tr>
                    <td class="center-align">{{ accountStatement.id }}</td>
                    <td class="center-align">{{ accountStatement.filename }}</td>
                    <td class="center-align">{{ accountStatement.dateCreated | localizedDate:'short' }}</td>
                    <td class="center-align">
                      <div class="status-badge"
                           [ngClass]="{'accepted': accountStatement.status === ImportStatus.CONFIRMED, 'denied':
                         accountStatement.status === ImportStatus.OPEN}">
                    <span class="fw-bold">
                      {{ accountStatement.status | importStatus | uppercase }}
                    </span>
                      </div>
                    </td>

                    <td class="text-end center-align">
                      <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                  <span class="menu-icon" id="eventActionsDropdown" ngbDropdownToggle>
                    <i class="fas fa-ellipsis-v"></i>
                  </span>
                        <ul aria-labelledby="eventActionsDropdown" ngbDropdownMenu>
                          <li ngbDropdownItem (click)="goToAccountStatementDetails(accountStatement)">{{
                              t("app.common.details")
                            }}
                          </li>
                          <li ngbDropdownItem (click)="deleteAccountStatement(accountStatement)">
                            {{ t("app.common.delete") }}
                          </li>
                        </ul>
                      </div>
                    </td>

                  </tr>
                }
              </tbody>
            </app-sortable-table>
          </div>
          <!-- Mobile -->
          @for (accountStatement of accountStatements;let isLast = $last;track accountStatement) {
            <div class="d-block d-xl-none">
              <div [class.isLastRow]="isLast" class="d-flex justify-content-center align-items-center mobile-table-row">
                <div class="flex-grow-1">
                  <div [class.isLastRow]="isLast" class="d-flex flex-column">
                    <div>
                      <strong>{{ t("account.statements.id") }}:</strong>{{ accountStatement.id }}
                    </div>
                    <div>
                      <strong>{{ t("account.statements.filename") }}:</strong>{{ accountStatement.filename }}
                    </div>
                    <div>
                      <strong>{{ t("account.statements.dateCreated") }}
                        :</strong>{{ accountStatement.dateCreated | localizedDate:'short' }}
                    </div>
                    <div>
                      <strong>{{ t("account.statements.status") }}
                        :</strong> {{ accountStatement.status | importStatus | uppercase }}
                    </div>
                  </div>
                </div>
                <div>
                  <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                <span class="menu-icon" id="eventActionsDropdownMobile" ngbDropdownToggle>
                  <i class="fas fa-ellipsis-v"></i>
                </span>
                    <ul aria-labelledby="eventActionsDropdownMobile" ngbDropdownMenu>
                      <li ngbDropdownItem (click)="goToAccountStatementDetails(accountStatement)">{{
                          t("app.common.details")
                        }}
                      </li>
                      <li ngbDropdownItem (click)="deleteAccountStatement(accountStatement)">{{
                          t("app.common.delete")
                        }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="pt-2 pb-4">
          <app-empty-state/>
        </div>
      }
    </div>
  </div>
</ng-container>

